import * as TYPES from '../types';

export const playerNote = (state ={}, action) => { // to review
    const newState = JSON.parse(JSON.stringify(state));
      switch (action.type) {
      case TYPES.GET_PLAYERS_NOTE_TYPE:
        if(!newState.playersNoteTypes){
          newState.playersNoteTypes = {};
        }
        newState.playersNoteTypes = action.playersNoteTypes;
        return newState;
    case TYPES.GET_PLAYER_NOTE:
      if(!newState.modalPlayerNote){
          newState.modalPlayerNote = [];
        }
      newState.modalPlayerNote = action.modalPlayerNote;
      return newState;
    default:
      return state;
    }
  };